import { MOBILE_APP_UNIVERSAL_LINK, INTERNET_BANKING_URL } from '../constants/links';
import { isMobileDevice } from './isMobileDevice';

export function getContinuationLink(): string {
    return isMobileDevice() ? MOBILE_APP_UNIVERSAL_LINK : INTERNET_BANKING_URL;
}
